import React, { useState } from "react";

import { trackMixpanel, useNavigate, useTranslation, useUserContext } from "utils";

import { Avatar, AvatarImage, Flex, Icon, Popover, Typography } from "components";

const ProfileMenuAvatar = ({ image, name, size, dataTestId }: { image: string | null; name: string; size: string; dataTestId: string }) => {
  if (image) {
    // @ts-expect-error convert to TS
    return <AvatarImage className="profile-menu avatar" dataTestId={`${dataTestId}-avatar-image`} size={size} image={image} />;
  }

  return <Avatar className="profile-menu avatar" dataTestId={`${dataTestId}-avatar`} size={size} name={name} />;
};

export const ProfileMenu = () => {
  const { t } = useTranslation("nav");
  const { user } = useUserContext();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  if (!user) return null;
  const name = `${user.firstName} ${user.lastName}`;

  const navigationItems = [
    {
      key: "0",
      dataTestId: "profile-menu-popover-content-menu-item-profile",
      iconName: "tabler/user",
      label: t("drawer.profile"),
      onClick: () => {
        setIsOpen(false);
        navigate("/user");
        trackMixpanel("ClickLink", {
          linkText: undefined,
          link: "/user",
        });
      },
    },
    {
      key: "1",
      iconName: "tabler/settings",
      dataTestId: "profile-menu-popover-content-menu-item-settings",
      onClick: () => {
        setIsOpen(false);
        navigate("/user/settings");
        trackMixpanel("ClickLink", {
          linkText: t("drawer.settings"),
          link: "/user/settings",
        });
      },
      label: t("drawer.settings"),
    },
    {
      key: "2",
      iconName: "tabler/logout",
      dataTestId: "profile-menu-popover-content-menu-item-sign-out",
      onClick: () => {
        setIsOpen(false);
        navigate("/sign-out");
        trackMixpanel("ClickLink", {
          linkText: t("drawer.logout"),
          link: "/sign-out",
        });
      },
      label: t("drawer.logout"),
    },
  ];

  const NavigationList = (
    <Flex className="profile-menu navigation-list" vertical={true}>
      {navigationItems.map((item) => (
        <Flex
          key={item.key}
          className="profile-menu navigation-list item"
          data-testid={item.dataTestId}
          align={"center"}
          justify={"flex-start"}
          gap={"1rem"}
          onClick={item.onClick}
        >
          <Icon iconName={item.iconName} />
          <Typography variant="paragraph-m">{item.label}</Typography>
        </Flex>
      ))}
    </Flex>
  );

  const ProfileMenuButton = (
    <Flex data-testid="profile-menu" className="profile-menu button pointer" justify="center" align="center" onClick={() => setIsOpen(!isOpen)} gap="0.5rem">
      <ProfileMenuAvatar dataTestId="profile-menu-preview" image={user.image} name={name} size="xs" />
      <Icon className={`profile-menu collapse-chevron ${!isOpen && "reverse"}`} iconName="tabler/chevron-up" />
    </Flex>
  );
  const ProfileMenuContent = (
    <Flex data-testid="profile-menu-popover-content" align="center" justify="center" vertical={true}>
      <Flex className="profile-menu info" align="center" justify="center" vertical={true} gap="0.5rem">
        <ProfileMenuAvatar dataTestId="profile-menu-popover-content" image={user.image} name={name} size="xm" />
        <Typography variant="h3" data-testid="profile-menu-popover-content-name">
          {name}
        </Typography>
        <Typography variant="paragraph-m" data-testid="profile-menu-popover-content-email" className="profile-menu email">
          {user.email}
        </Typography>
      </Flex>
      {NavigationList}
    </Flex>
  );
  return (
    <Popover
      dataTestId="profile-menu-popover"
      className="profile-menu"
      placement="bottomRight"
      arrow={false}
      content={ProfileMenuContent}
      trigger="click"
      open={isOpen}
      onOpenChange={() => setIsOpen(!isOpen)}
    >
      {ProfileMenuButton}
    </Popover>
  );
};
